"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var router_1 = require("@angular/router");
var results_component_1 = require("./results.component");
var routes = [
    {
        path: '',
        component: results_component_1.ResultsComponent
    }
];
var ResultsRoutingModule = /** @class */ (function () {
    function ResultsRoutingModule() {
    }
    return ResultsRoutingModule;
}());
exports.ResultsRoutingModule = ResultsRoutingModule;
var ResultsModules = /** @class */ (function () {
    function ResultsModules() {
    }
    return ResultsModules;
}());
exports.ResultsModules = ResultsModules;
